import React from 'react';
import { InventoryIssueRow } from '../callCenterInventoryIssuesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './InventoryIssuesTable.module.css';

interface InventoryIssuesTableProps {
  rows: InventoryIssueRow[];
  onView?: (id: string) => void;
}

export const InventoryIssuesTable: React.FC<InventoryIssuesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="Inventory Issues">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>SKU</th>
              <th>WAREHOUSE</th>
              <th>ISSUE TYPE</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td>{row.sku}</td>
                <td className={sharedStyles.bold}>{row.warehouse}</td>
                <td className={styles.issueType}>{row.issueType}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
